import React, { useEffect, useRef, useState } from "react";
import { useInViewport } from "react-in-viewport";

// Hooks
import useDevice from "../../hooks/useDevice";

// Components
import { Fade, Typography, Divider } from "@mui/material";

const Gift = (props) => {
  const contentRef = useRef();
  const [startTransition, setStartTransition] = useState(false);
  const { inViewport } = useInViewport(contentRef);
  const { device } = useDevice();

  useEffect(() => {
    if (inViewport) setStartTransition(true);
  }, [inViewport]);

  return (
    <div {...props} className={`vjc_main-gift ${device}`}>
      <Divider>
        <Typography variant="h1" sx={{ fontSize: "26px" }}>
          Gift Guide
        </Typography>
      </Divider>

      <Fade in={startTransition} timeout={2500}>
        <Typography variant="body2" color="text.secondary" ref={contentRef}>
          WE'RE SO GRATEFUL TO HAVE YOU CELEBRATE THIS SPECIAL DAY WITH US! INDEED, YOUR PRESENCE IS WHAT
          WOULD MATTER THE MOST.
        </Typography>
      </Fade>

      <Fade in={startTransition} timeout={3500}>
        <Typography variant="body2" color="text.secondary">
          <span style={{ fontWeight: "700" }}>
            IF YOU'D LIKE TO SHARE A LITTLE LOVE THROUGH A MONETARY GIFT, IT WILL SURELY HELP US BUILD OUR
            FUTURE TOGETHER.
          </span>
        </Typography>
      </Fade>
    </div>
  );
};

export default Gift;
